export class Signup {
    id: number;
    name: string;
    email: string;
    phone: string;
    password: string;
  }
  